var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accounts"},[(_vm.accounts)?_c('div',{staticClass:"chart"},[_c('apexchart',{attrs:{"type":"bar","height":"500","options":_vm.options,"series":_vm.series}})],1):_c('b-spinner',{staticClass:"spinner",attrs:{"label":"Large Spinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }